var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.site.logos)?_c('div',{staticClass:"logo p"},[(_vm.inview)?_vm._l((_vm.site.logos),function(img,index){return _c('img',{key:index,class:{ active: _vm.scrollIndex == index },attrs:{"src":img.url,"alt":""}})}):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }